import {Link, NavLink} from 'react-router-dom'
import {FiClipboard, FiUsers, FiSettings, FiUser} from 'react-icons/fi'

import styles from './Navbar.module.css'
import logo from '../../img/costs_logo.png';
import { useState } from 'react';

import Container from './Container'
function Navbar() {

    const [userSession] = useState(JSON.parse(localStorage.getItem('userSession')))
    const [dropdownActive, setDropDownActive] = useState(false)
    const [dropdownActive2, setDropDownActive2] = useState(false)

    function toggleDropdown() {
        setDropDownActive(!dropdownActive)
    }
    
    function toggleDropdown2() {
        setDropDownActive2(!dropdownActive2)
    }

    return (
        <nav className={styles.navbar}>
        <Container>
            <Link to="/" className={styles.brand}>
                <img src={logo} alt="Home" />
            </Link>

            <ul className={styles.list}>
                <li className={styles.item}>
                    <NavLink to="/chamados" className={({isActive}) => `${styles.itemLink} ${isActive ? styles.itemActive : ''}`}><FiClipboard /> Chamados</NavLink>
                </li>
                <li className={styles.item}>
                    <NavLink to="/usuarios" className={({isActive}) => `${styles.itemLink} ${isActive ? styles.itemActive : ''}`}><FiUsers /> Usuários</NavLink>
                </li>
                <li className={`${styles['item']} ${styles['dropdown']}`}>
                    <span className={styles.itemLink} onClick={toggleDropdown2}><FiSettings /> Configurações</span>
                    <ul className={((dropdownActive2 && styles.active) || '')}>
                        <li><Link to="/grupos">Grupos</Link></li>
                        <li><Link to="/motivos">Motivos</Link></li>
                        <li><Link to="/regras">Regras</Link></li>
                    </ul>
                </li>
                <li className={`${styles['item']} ${styles['dropdown']}`}>
                    <span className={styles.userChip} onClick={toggleDropdown}><FiUser /> {userSession.CD_USUARIO}</span>
                    <ul className={((dropdownActive && styles.active) || '')}>
                        <li><Link to="/perfil">Perfil</Link></li>
                        <li><Link to="/logout">Sair</Link></li>
                    </ul>
                </li>
            </ul>
        </Container>
        </nav>
    )
}

export default Navbar
